<script lang="ts">
	import { PrismicLink } from '@prismicio/svelte';

	const { socials } = $props();

	const year = new Date().getFullYear();
	const channels = socials.data.channels;
</script>

<footer class="main-footer">
	<div class="container">
		{#if channels.length}
			<h6 class="main-footer__social--title">Follow us</h6>

			<div class="main-footer__social">
				{#each channels as channel}
					<PrismicLink field={channel} />
				{/each}
			</div>
		{/if}

		<div class="d-flex flex-column align-items-center justify-content-center">
			<p class="main-footer__copyright">&copy; {year}, Cardiff Eagles Ice Hockey Club.</p>
			<p class="main-footer__copyright">All rights reserved.</p>
			<p class="main-footer__credit">
				Made by <a href="https://www.leejones.me.uk" target="blank">Lee Jones</a>
			</p>
		</div>
	</div>
</footer>
